import React from 'react'

export default function Loan () {
  return (
    <div>
      Loan
    </div>
  )
}
